<mat-form-field class="col-12">
    <mat-label for="street">Billing address</mat-label>
    <input
        matInput
        #autocompleteAddress
        id="autocomplete"
        type="text"
        [formControlName]="fieldName"
        [placeholder]="placeholder"
    />
    <mat-error>
        <ng-content select="app-field-error" />
    </mat-error>
</mat-form-field>
